import React from 'react';
import { SearchIconSmall as HmIconSmall, SearchIconMedium as HmIconMedium, SearchIcon as HmIcon, } from '../brand/hm/SearchIcon';
import { SearchIconSmall as HmGroupIconSmall, SearchIconMedium as HmGroupIconMedium, SearchIcon as HmGroupIcon, } from '../brand/hmGroup/SearchIcon';
import { SearchIconSmall as MonkiIconSmall, SearchIconMedium as MonkiIconMedium, SearchIcon as MonkiIcon, } from '../brand/monki/SearchIcon';
import { SearchIconSmall as NorthstarIconSmall, SearchIconMedium as NorthstarIconMedium, SearchIcon as NorthstarIcon, } from '../brand/northstar/SearchIcon';
import { SearchIconSmall as OtherStoriesIconSmall, SearchIconMedium as OtherStoriesIconMedium, SearchIcon as OtherStoriesIcon, } from '../brand/otherStories/SearchIcon';
export const SearchIconSmall = (props) => {
    switch (process.env.BRAND) {
        case 'hmGroup':
            return React.createElement(HmGroupIconSmall, { ...props });
        case 'monki':
            return React.createElement(MonkiIconSmall, { ...props });
        case 'northstar':
            return React.createElement(NorthstarIconSmall, { ...props });
        case 'otherStories':
            return React.createElement(OtherStoriesIconSmall, { ...props });
        case 'hm':
        default:
            return React.createElement(HmIconSmall, { ...props });
    }
};
export const SearchIconMedium = (props) => {
    switch (process.env.BRAND) {
        case 'hmGroup':
            return React.createElement(HmGroupIconMedium, { ...props });
        case 'monki':
            return React.createElement(MonkiIconMedium, { ...props });
        case 'northstar':
            return React.createElement(NorthstarIconMedium, { ...props });
        case 'otherStories':
            return React.createElement(OtherStoriesIconMedium, { ...props });
        case 'hm':
        default:
            return React.createElement(HmIconMedium, { ...props });
    }
};
export const SearchIcon = (props) => {
    switch (process.env.BRAND) {
        case 'hmGroup':
            return React.createElement(HmGroupIcon, { ...props });
        case 'monki':
            return React.createElement(MonkiIcon, { ...props });
        case 'northstar':
            return React.createElement(NorthstarIcon, { ...props });
        case 'otherStories':
            return React.createElement(OtherStoriesIcon, { ...props });
        case 'hm':
        default:
            return React.createElement(HmIcon, { ...props });
    }
};
export default SearchIcon;
//# sourceMappingURL=SearchIcon.js.map